import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie';

export const manageUserApi = createApi({
    reducerPath: "manageUserApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_URL}`,
        prepareHeaders: (headers, { getState }) => {
            const { auth } = getState();
            const token = auth.user.token
            headers.set('Authorization', `Bearer ${token}`);
            headers.set('Content-Type', `application/json;charset=UTF-8`);
            return headers;
        },
    }),
    tagTypes: ["ManageUser"],
    endpoints: (builder) => ({
        addUser: builder.mutation({
            query: (data) => {
                return {
                    url: "/Auth/addUser",
                    method: "POST",
                    body: data
                }
            },
            invalidatesTags: ["ManageUser"],
        }),
        allExistingUsers: builder.query({
            query: (data) => {
                return {
                    url: "/api/Users/User-list",
                    method: "GET",
                    params: data
                }
            },
            providesTags: ["ManageUser"],
        }),
        getUserById: builder.query({
            query: (userId) => {
                return {
                    url: "/api/Users/User-list",
                    method: "GET",
                    params: userId
                }
            },
            providesTags: ["ManageUser"],
        }),
        editUser: builder.mutation({
            query: (data) => {
                return {
                    url: "/api/users/update-users",
                    method: "POST",
                    body: data
                }
            },
            invalidatesTags: ["ManageUser"],
        }),
        deleteUser: builder.mutation({
            query: (data) => {
                return {
                    url: `/api/users/DeleteUser?keyID=${data}`,
                    method: "POST",
                    body: data
                }
            },
            invalidatesTags: ["ManageUser"],
        }),
        statusChange: builder.mutation({
            query: (data) => {
                return {
                    url: `/api/users/UpdateUserStatus`,
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["ManageUser"],
        }),
        updateUser: builder.mutation({
            query: (data) => {
                return {
                    url: `/api/users/update-users`,
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["ManageUser"],
        }),
    }),
});

export const {useAddUserMutation, 
    useAllExistingUsersQuery, useGetUserByIdQuery, useEditUserMutation, useDeleteUserMutation, 
    useStatusChangeMutation, useUpdateUserMutation} = manageUserApi;
